var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-file-input',{attrs:{"clearable":"","dense":"","accept":_vm.accept,"error-messages":_vm.errorMessages,"label":_vm.label},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }